import $ from 'jquery';
import 'bootstrap/js/dist/modal'

export const makeFormData = (parent) => {
    const data = {};

    parent.find('input[name]').each(function () {
        const name = $(this).attr('name');

        data[name] = $(this).val();
    });

    return data;
};

export const makeAuthFormData = (parent, token) => {
    const data = makeFormData(parent);
    data.reCaptcha = token;

    return data;
};